import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBundleItems } from '@guryou/redux';

const useBundleItems = ({ id }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.bundle.getItems);
  // getItems is a single shared slot, and the reducer drops `request` on ERROR — so a
  // status-based guard can't tell which bundle was last fetched and would either skip the
  // fetch (stuck after one error) or loop. Track the last id we fetched locally instead:
  // fetch once per id per mount, regardless of the slot's status. The expand row remounts
  // BundleItems on each open, so reopening a bundle naturally retries a failed fetch.
  const fetchedId = useRef(null);
  useEffect(() => {
    if (id && fetchedId.current !== id) {
      fetchedId.current = id;
      dispatch(getBundleItems(id));
    }
  }, [dispatch, id]);

  return { data: data || [], status, version, entity };
};

export default useBundleItems;
